import React from 'react';
import styled from '@emotion/styled';
import { Box } from '@mui/material';
import { GamifyIcon } from 'application/components/GamifyIcon';

// Re-export all components from CustomInputs.styles.ts
export * from './custom-inputs/CustomInputs.styles';

// Image components that are unique to GameFormComponents
export const ImageSection = styled.div`
  margin-top: 24px;
`;

export const ImageLabel = styled.div`
  font-size: 14px;
  color: #555;
  margin-bottom: 12px;
`;

export const ImageUploadContainer = styled.div<{ theme?: any }>`
  background-color: ${({ theme }) => theme?.custom?.background1 || '#fff'};
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  border: 1px solid ${({ theme }) => theme?.custom?.stroke || '#e0e0e0'};
`;

export const AddImageButton = styled.div<{ theme?: any }>`
  display: flex;
  align-items: center;
  background-color: ${({ theme }) => theme?.custom?.primary || '#ff8a65'};
  border-radius: 8px;
  padding: 6px 16px;
  cursor: pointer;
  gap: 8px;
`;

export const AddImageText = styled.div`
  color: white;
  font-size: 13px;
  font-weight: 500;
`;

export const ImagePreviewContainer = styled.div`
  margin-left: 12px;
  display: flex;
  align-items: center;
`;

export const ImagePreview = styled.img`
  height: 32px;
  width: auto;
  margin-right: 8px;
  border-radius: 4px;
`;

export const ImageName = styled.span`
  font-size: 13px;
  color: #333;
`;

// Round specific components
export const RoundHeader = styled.div`
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 24px;
  border-bottom: 1px solid #d0d2d8;
  padding-bottom: 16px;
`;

export const NextRoundButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px 20px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 14px;
  background-color: var(--fi-button, #ff6a00);
  color: var(--fi-button-text, white);
  border: none;
  cursor: pointer;
  transition: all 0.2s;
  min-width: 110px;

  &:hover {
    opacity: 0.9;
  }

  &:disabled {
    background-color: #e0e0e0;
    color: #999;
    cursor: not-allowed;
  }
`;

export const NextRoundIcon = styled.img`
  width: 16px;
  height: 16px;
`;

// Reward card components
export const RewardsGrid = styled(Box)({
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))',
  gap: '16px',
  padding: '16px',
});

export const RewardCard = styled(Box)(({ theme }: { theme: any }) => ({
  backgroundColor: theme?.custom?.background2 || '#ffffff',
  borderRadius: '12px',
  overflow: 'hidden',
  boxShadow: theme?.shadows?.[2] || '0px 2px 4px rgba(0, 0, 0, 0.1)',
  transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
  '&:hover': {
    transform: 'translateY(-2px)',
    boxShadow: theme?.shadows?.[4] || '0px 4px 8px rgba(0, 0, 0, 0.15)',
  },
}));

export const PointsRewardCard = styled(Box)(({ theme }: { theme: any }) => ({
  backgroundColor: theme?.custom?.background2 || '#ffffff',
  borderRadius: '12px',
  padding: '16px',
  boxShadow: theme?.shadows?.[2] || '0px 2px 4px rgba(0, 0, 0, 0.1)',
  transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
  '&:hover': {
    transform: 'translateY(-2px)',
    boxShadow: theme?.shadows?.[4] || '0px 4px 8px rgba(0, 0, 0, 0.15)',
  },
}));

// Helper functions
export const renderGamifyIcon = (
  icon: string,
  color: string = 'white',
  size: number = 16
) => <GamifyIcon icon={icon} color={color} height={size} width={size} />;

export const SectionTitle = styled.div`
  // font-weight: 700;
  // font-size: 14px;
  // margin-bottom: 20px;
  // padding-bottom: 10px;
  color: #6f878f;
  font-family: Manrope;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px; /* 200% */
  letter-spacing: -0.24px;
`;
